import { html } from "./ElementBuilder.js";
import { render } from "./render/mod.js";
function getElementAttributes(el) {
    return el
        .getAttributeNames()
        .reduce((result, name) => {
        const value = el.getAttribute(name);
        if (value !== null) {
            result[name] = value;
        }
        return result;
    }, {});
}
/**
 * Renders the given element to a string.
 *
 * @internal scope: workspace
 */
// TODO: This function is very similar to `renderElement` in the `render` module.
// Refactor to avoid duplication.
export async function renderElementToString({ children, element, options, contents, shadowRootMode, }) {
    const attributes = getElementAttributes(element);
    const tagName = element.tagName.toLowerCase();
    const resolvedContents = shadowRootMode
        ? html.template.shadowrootmode(shadowRootMode).$children(contents)
        : contents;
    return render(html[tagName]
        .$attrs(attributes)
        .$children(resolvedContents, html.fragment.$innerHTML(children)), options);
}
